// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"22d1fb27","787":"0e6c9168"}[chunkId] + ".chunk.js";
};